import { render, staticRenderFns } from "./CurricularMesh.vue?vue&type=template&id=ad47c84c&scoped=true"
import script from "./CurricularMesh.vue?vue&type=script&lang=js"
export * from "./CurricularMesh.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=ad47c84c&prod&scoped=true&lang=css&external"
import style1 from "./CurricularMesh.vue?vue&type=style&index=1&id=ad47c84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad47c84c",
  null
  
)

export default component.exports